import { createAction, createStandardAction, createAsyncAction } from 'typesafe-actions';
export var authActions = {
  isAuthenticated: createStandardAction('AUTH_IS_AUTHENTICATED')(),
  guestMode: createStandardAction('AUTH_GUEST_MODE')(),
  setCredential: createStandardAction('AUTH_SET_CREDENTIAL')(),
  setError: createAction('AUTH_SET_ERROR', function (resolve) {
    return function (error, source) {
      return resolve({
        error: error,
        source: source
      });
    };
  }),
  setLogin: createAction('AUTH_SET_LOGIN', function (resolve) {
    return function (hasLogin, loginPath) {
      return resolve({
        hasLogin: hasLogin,
        loginPath: loginPath
      });
    };
  }),
  setRegister: createAction('AUTH_SET_REGISTER', function (resolve) {
    return function (hasRegister, registerPath) {
      return resolve({
        hasRegister: hasRegister,
        registerPath: registerPath
      });
    };
  }),
  setForgot: createAction('AUTH_SET_FORGOT', function (resolve) {
    return function (hasForgot, forgotPath) {
      return resolve({
        hasForgot: hasForgot,
        forgotPath: forgotPath
      });
    };
  }),
  auth: createAsyncAction('AUTH_REQUEST', 'AUTH_SUCCESS', 'AUTH_FAILURE')()
};